
import * as React from 'react'
import {CSSProperties} from 'react';
import {MajorAccountsHdr} from '../Components/MajorAccountsHdr';
import * as Tgcc from '../tgccGlobal';
import {MajorAccountsFooter} from '../Components/MajorAccountsFooter';
import Radium, { StyleRoot } from 'radium';


const contactStyles: CSSProperties = {
    height:'auto',
    width:'100%',
}

const statementStyles: CSSProperties = {
    fontFamily:'BarlowLight',
    textAlign:'center',
    fontSize:'14px',
    marginTop:'150px',
}
const statementDivStyles: CSSProperties = {
    width: '45%',
    margin:'auto',
    color:'#404041',
    '@media (max-width:375px)' : {
        width:'100%'
    },
    '@media (max-width:320px)' : {
        width:'100%',
    }
}

const getInTouch: CSSProperties = {
    fontFamily:'Lulo',
    textAlign:'center',
    marginTop:'40px',
    color:'#616060',
    fontSize:'22px',
    letterSpacing:'0.2em'
}

const contactDiv: CSSProperties = {
    display:'inline-block',
    marginRight:'82px'
}
const contactHdr: CSSProperties = {
    display:'inline-block',
    marginRight:'82px'
}

const hdrStyle: CSSProperties = {
    textAlign:'center',
    marginLeft:'68px',
    marginTop:'50px'
}
const hdr: CSSProperties = {
    fontFamily:'BarlowMedium',
    color:'#616060',
    letterSpacing:'0.2em'
}
const subHdr: CSSProperties = {
    fontFamily:'BarlowLight',
    color:'#616060'
}
const email: CSSProperties = {
    textAlign:'center',
    fontFamily:'BarlowLight',
    marginTop:'50px',
    color:'#616060',
    marginBottom:'100px'
}
const emailBtn: CSSProperties = {
    width:'370px',
    height:'40px',
    backgroundColor:'#E27558',
    color:'white',
    padding:'5px',
    lineHeight:'40px',
    margin:'20px auto',
    fontFamily:'Lulo'
}


class _MajorAccountsContact extends React.Component<Tgcc.BaseProps,any> {
    state = {
        contactPage:""
    }
    componentWillMount(){
        this.setState({contactPage: "contactPage"});
    }
    componentDidMount(){
        var tag = document.getElementById('campusContact');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }
    render () {
        return (
              <div style={contactStyles}>
                <div id='campusContact'></div>
                    <MajorAccountsHdr />
                        <div style={statementDivStyles} className='statementDiv'>
                            <p style={statementStyles} className='statementStyles'>Here at the Graphic Cow, we believe in reliable customer service. You will be connected with a person who understands what’s important to you.</p>
                        </div>
                            <div style={getInTouch}>GET IN TOUCH</div>
                            <div>
                                <div style={hdrStyle} className="campusContactHdr">
                                    <div style={contactDiv} className="campusContactDiv">
                                        <div style={hdr}>OUR LOCATION</div>
                                        <br/>
                                        <div style={subHdr}>400 S Pleasantburg Dr.</div>
                                        <div style={subHdr}>Suite B</div>
                                        <div style={subHdr}>Greenville, SC 29607</div>
                                    </div>
                                    <div style={contactDiv} className="campusCustService">
                                        <div style={hdr}>CUSTOMER SERVICE</div>
                                        <br/>
                                        <div style={subHdr}>Tel: 800-472-3269 ext.1</div>
                                        <div style={subHdr}>sales@grafcow.com</div>
                                        <br />
                                    </div>
                                    <div style={contactDiv} className="campusContactDiv">
                                        <div style={hdr}>OFFICE HOURS</div>
                                        <br/>                                       
                                        <div style={subHdr}>Mon - Thurs 9am-5pm </div>
                                        <div style={subHdr}>Friday 9am-4pm</div>
                                        <br />
                                    </div>
                                </div>
                            </div>
                            <div style={email}>
                                <div>For Any Questions, Comments or Concerns</div>
                                <div style={emailBtn} className="campusContactBtn"><a href='mailto:sales@grafcow.com'>sales@grafcow.com</a></div>
                            </div>
                        <MajorAccountsFooter  state={this.props.state} />
                    </div>
        )
    }
}

export var MajorAccountsContact = Radium(_MajorAccountsContact);